import { roundTo } from "../utils/mathUtils";
import {
  teamCol,
  confCol,
  yearCol,
  divCol,
  numCol,
  round1Col,
  round2Col,
  round0Col,
  pctColWithSort,
  warCol,
  sosAdjWarCol,
} from "./leaderboards/helpers";

const teamPitchingRecordStats = [
  numCol("W", "w", "4rem"),
  numCol("L", "l", "4rem"),
  numCol("SV", "sv", "4rem"),
  numCol("GS", "gs", "4rem"),
  numCol("App", "app", "5rem"),
  round1Col("IP", "ip", "5rem"),
  numCol("BF", "bf", "4rem"),
  {
    name: "Pulls",
    selector: (row) => roundTo((row.app - row.gs) / row.gs, 1),
    sortable: true,
    width: "6rem",
    className: "text-center",
  },
];

const teamPitchingAllowedStats = [
  numCol("H", "h", "4rem"),
  numCol("R", "r", "4rem"),
  numCol("ER", "er", "4rem"),
  numCol("BB", "bb", "4rem"),
  numCol("SO", "so", "4rem"),
  numCol("HBP", "hbp", "5rem"),
  numCol("HR", "hr_a", "4rem"),
];

const teamPitchingEraStats = [
  round2Col("ERA", "era", "5rem"),
  round2Col("RA9", "ra9", "5rem"),
  round0Col("ERA+", "era_plus", "5rem"),
];

const teamPitchingRateStats = [
  round2Col("K/9", "k9", "5rem"),
  round2Col("BB/9", "bb9", "5rem"),
  round2Col("HR/9", "hr9", "5rem"),
  round2Col("H/9", "h9", "5rem"),
];

const teamPitchingAdvanced = [
  pctColWithSort("K%", "k_pct"),
  pctColWithSort("BB%", "bb_pct"),
  pctColWithSort("K-BB%", "k_minus_bb_pct", "6rem"),
  pctColWithSort("HR/FB", "hr_div_fb", "6rem"),
];

const teamPitchingValue = [
  round1Col("Clutch", "clutch", "6rem"),
  round1Col("pWPA", "pwpa", "6rem"),
  round1Col("pWPA/LI", "pwpa_li", "7rem"),
  round1Col("pREA", "prea", "6rem"),
];

const teamPitchingOther = [
  numCol("GO", "go", "4rem"),
  numCol("FO", "fo", "4rem"),
];

export function getTeamPitchingColumns() {
  return [
    teamCol("10rem"),
    confCol(),
    divCol(),
    yearCol(),
    ...teamPitchingRecordStats,
    ...teamPitchingAllowedStats,
    ...teamPitchingEraStats,
    ...teamPitchingRateStats,
    ...teamPitchingAdvanced,
    ...teamPitchingValue,
    warCol("5rem"),
    sosAdjWarCol("8rem"),
    ...teamPitchingOther,
  ];
}
